var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 16V17.3333C4 18.0406 4.25934 18.7189 4.72097 19.219C5.1826 19.719 5.8087 20 6.46154 20H17.5385C18.1913 20 18.8174 19.719 19.279 19.219C19.7407 18.7189 20 18.0406 20 17.3333V16","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8 11L12 15L16 11","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M12 15L12 5","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Download.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Download;

Download.default = Download;
